/* eslint-disable */ 
jQuery(document).ready( () => {
  jQuery('.maskTell').mask('(99) 9 9999-9999', { placeholder: '(00) 0 0000-0000' });
  jQuery('.maskCpf').mask('999.999.999-99', { placeholder: '000.000.000-00' });
  jQuery('.maskDate').mask('00/00/0000', { placeholder: 'dd/mm/aaaa' });
});
